(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-header"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.zh-header').forEach(function (header) {
    var toggle = header.querySelector('.zh-mobile-toggle');
    var mobileNav = header.querySelector('.zh-mobile-nav');
    if (!toggle || !mobileNav) return;

    // Move the drawer to <body> so it can never get trapped inside a
    // transformed / sticky-header ancestor, which breaks position:fixed
    // and was causing the drawer to render in the wrong place (or not
    // visibly open at all).
    document.body.appendChild(mobileNav);

    function positionMobileNav() {
      var headerRect = header.getBoundingClientRect();
      mobileNav.style.top = headerRect.bottom + 'px';
      mobileNav.style.height = (window.innerHeight - headerRect.bottom) + 'px';
    }

    toggle.addEventListener('click', function () {
      var isOpen = mobileNav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      document.body.classList.toggle('zh-menu-open', isOpen);
      if (isOpen) {
        positionMobileNav();
      }
    });

    window.addEventListener('resize', function () {
      if (mobileNav.classList.contains('is-open')) {
        positionMobileNav();
      }
    });

    // Query from mobileNav now, not header — mobileNav has already
    // been moved out to <body> by this point.
    mobileNav.querySelectorAll('.zh-mobile-caret-btn').forEach(function (caretBtn) {
      caretBtn.addEventListener('click', function () {
        var item = caretBtn.closest('.zh-mobile-has-sub');
        if (!item) return;
        var expanded = item.classList.toggle('is-expanded');
        caretBtn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      });
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-product-grid"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.pgrid-section').forEach(function (section) {
    var trigger = section.querySelector('.pgrid-sort-trigger');
    var overlay = section.querySelector('.pgrid-sort-overlay');
    var sheet = section.querySelector('.pgrid-sort-sheet');
    var closeBtn = section.querySelector('.pgrid-sort-close');
    var options = section.querySelectorAll('.pgrid-sort-option');
    if (!trigger || !overlay || !sheet) return;

    var wrap = section.querySelector('.pgrid-sort-wrap');

    function isMobileSheet() {
      return window.matchMedia('(max-width: 640px)').matches;
    }

    function openSheet() {
      overlay.classList.add('is-open');
      sheet.classList.add('is-open');
      if (isMobileSheet()) document.body.style.overflow = 'hidden';
    }

    function closeSheet() {
      overlay.classList.remove('is-open');
      sheet.classList.remove('is-open');
      document.body.style.overflow = '';
    }

    trigger.addEventListener('click', function (e) {
      e.stopPropagation();
      if (sheet.classList.contains('is-open')) {
        closeSheet();
      } else {
        openSheet();
      }
    });
    overlay.addEventListener('click', closeSheet);
    if (closeBtn) closeBtn.addEventListener('click', closeSheet);

    document.addEventListener('click', function (e) {
      if (!isMobileSheet() && wrap && !wrap.contains(e.target)) {
        closeSheet();
      }
    });

    options.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var value = btn.getAttribute('data-sort-value');
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', value);
        url.searchParams.delete('page');
        window.location.href = url.toString();
      });
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-products"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.featured-carousel').forEach(function (carousel) {
    var row = carousel.querySelector('[data-featured-row]');
    var prevBtn = carousel.querySelector('[data-featured-prev]');
    var nextBtn = carousel.querySelector('[data-featured-next]');
    if (!row || !prevBtn || !nextBtn) return;

    function scrollByCard(direction) {
      var card = row.querySelector('.featured-card');
      if (!card) return;
      var cardWidth = card.getBoundingClientRect().width;
      var gap = parseFloat(getComputedStyle(row).columnGap || getComputedStyle(row).gap || 0) || 0;
      row.scrollBy({ left: direction * (cardWidth + gap), behavior: 'smooth' });
    }

    function updateArrowState() {
      var maxScroll = row.scrollWidth - row.clientWidth;
      var atStart = row.scrollLeft <= 4;
      var atEnd = row.scrollLeft >= maxScroll - 4;
      prevBtn.classList.toggle('is-dark', !atStart);
      nextBtn.classList.toggle('is-dark', !atEnd);
    }

    row.addEventListener('scroll', function () {
      window.requestAnimationFrame(updateArrowState);
    });
    window.addEventListener('resize', updateArrowState);
    updateArrowState();

    prevBtn.addEventListener('click', function () { scrollByCard(-1); });
    nextBtn.addEventListener('click', function () { scrollByCard(1); });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.pprod-section').forEach(function (root) {

    /* ---------- Gallery ---------- */
    var track = root.querySelector('.pprod-gallery-track');
    var dots = root.querySelectorAll('.pprod-dot');
    var prevBtn = root.querySelector('.pprod-gallery-prev');
    var nextBtn = root.querySelector('.pprod-gallery-next');
    var slides = root.querySelectorAll('.pprod-gallery-slide');

    function goToSlide(index) {
      if (!track || !slides.length) return;
      index = Math.max(0, Math.min(index, slides.length - 1));
      track.scrollTo({ left: slides[index].offsetLeft, behavior: 'smooth' });
    }

    function currentSlideIndex() {
      if (!track) return 0;
      var scrollLeft = track.scrollLeft;
      var closest = 0;
      var closestDist = Infinity;
      slides.forEach(function (slide, i) {
        var dist = Math.abs(slide.offsetLeft - scrollLeft);
        if (dist < closestDist) { closestDist = dist; closest = i; }
      });
      return closest;
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { goToSlide(currentSlideIndex() - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { goToSlide(currentSlideIndex() + 1); });

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        goToSlide(parseInt(dot.getAttribute('data-index'), 10));
      });
    });

    if (track) {
      var scrollTimeout;
      track.addEventListener('scroll', function () {
        clearTimeout(scrollTimeout);
        scrollTimeout = setTimeout(function () {
          var idx = currentSlideIndex();
          dots.forEach(function (d, i) { d.classList.toggle('is-active', i === idx); });
        }, 80);
      });
    }

    function goToSlideByMediaId(mediaId) {
      var slideArr = Array.prototype.slice.call(slides);
      var idx = slideArr.findIndex(function (s) { return s.getAttribute('data-media-id') === String(mediaId); });
      if (idx > -1) goToSlide(idx);
    }

    /* ---------- Countdown timer ---------- */
    var timerEl = root.querySelector('.pprod-timer');
    if (timerEl) {
      var clockEl = timerEl.querySelector('[data-timer-clock]');
      var hours = parseInt(timerEl.getAttribute('data-timer-hours'), 10) || 6;
      var productId = timerEl.getAttribute('data-product-id');
      var storageKey = 'pprod_timer_deadline_' + productId;
      var deadline = parseInt(localStorage.getItem(storageKey), 10);
      var now = Date.now();

      if (!deadline || isNaN(deadline) || deadline <= now) {
        deadline = now + hours * 60 * 60 * 1000;
        localStorage.setItem(storageKey, String(deadline));
      }

      function pad(n) { return String(n).padStart(2, '0'); }

      function renderClock() {
        var remaining = deadline - Date.now();
        if (remaining <= 0) {
          deadline = Date.now() + hours * 60 * 60 * 1000;
          localStorage.setItem(storageKey, String(deadline));
          remaining = deadline - Date.now();
        }
        var h = Math.floor(remaining / 3600000);
        var m = Math.floor((remaining % 3600000) / 60000);
        var s = Math.floor((remaining % 60000) / 1000);
        clockEl.textContent = pad(h) + 'h ' + pad(m) + 'm ' + pad(s) + 's';
      }

      renderClock();
      setInterval(renderClock, 1000);
    }

    /* ---------- Variant picker ---------- */
    var form = root.querySelector('.pprod-form');
    var variantJsonEl = root.querySelector('[data-variant-json]');
    var variants = variantJsonEl ? JSON.parse(variantJsonEl.textContent) : [];
    var selects = root.querySelectorAll('.pprod-variant-select');
    var addCartBtn = root.querySelector('[data-add-cart]');
    var buyNowBtn = root.querySelector('[data-buy-now]');
    var addCartLabel = root.querySelector('[data-add-cart-label]');
    var statusMsg = root.querySelector('[data-status-msg]');
    var priceEl = root.querySelector('[data-price]');
    var comparePriceEl = root.querySelector('[data-compare-price]');
    var qtyInput = root.querySelector('[data-qty-input]');

    var MODEL_REQUIRED_MESSAGE = 'Please choose an option to continue.';

    var moneyFormat = function (cents) {
      return (cents / 100).toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 2 });
    };
    var currencySymbol = (priceEl && priceEl.textContent.match(/^[^\d]+/)) ? priceEl.textContent.match(/^[^\d]+/)[0] : '';

    function findMatchingVariant() {
      if (!selects.length) return variants[0] || null;
      var selectedValues = [];
      var allSelected = true;
      selects.forEach(function (sel) {
        if (!sel.value) allSelected = false;
        selectedValues.push(sel.value);
      });
      if (!allSelected) return null;

      return variants.find(function (v) {
        var opts = [v.option1, v.option2, v.option3].filter(function (o) { return o !== null && o !== undefined; });
        return opts.length === selectedValues.length && opts.every(function (o, i) { return o === selectedValues[i]; });
      }) || null;
    }

    /* Clears the red "select your model" state from every dropdown. */
    function clearOptionErrors() {
      selects.forEach(function (sel) {
        sel.classList.remove('is-invalid');
        var option = sel.closest('.pprod-option');
        var errEl = option ? option.querySelector('[data-option-error]') : null;
        if (errEl) errEl.textContent = '';
      });
    }

    /* Highlights the first dropdown that has no value, shows the red
       message under it, and scrolls it into view (important on mobile,
       where the buttons are far below the dropdown). */
    function showOptionError() {
      var target = null;
      selects.forEach(function (sel) {
        if (!target && !sel.value) target = sel;
      });
      if (!target) return;

      var option = target.closest('.pprod-option');
      var errEl = option ? option.querySelector('[data-option-error]') : null;

      target.classList.add('is-invalid');
      if (errEl) errEl.textContent = MODEL_REQUIRED_MESSAGE;

      statusMsg.textContent = '';
      statusMsg.className = 'pprod-status-msg';

      if (option && option.scrollIntoView) {
        option.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }

    /* Returns true when a variant is chosen. Otherwise shows the red
       message and returns false so the click does nothing else. */
    function ensureVariantSelected() {
      if (currentVariantId()) return true;
      showOptionError();
      return false;
    }

    function updateForVariant(variant) {
      clearOptionErrors();

      /* No model chosen yet: keep both buttons clickable so customers
         never think the product is out of stock. The click handlers
         show the red message instead. */
      if (!variant) {
        addCartBtn.disabled = false;
        buyNowBtn.disabled = false;
        addCartLabel.textContent = 'Add to cart';
        statusMsg.textContent = '';
        statusMsg.className = 'pprod-status-msg';
        return;
      }

      if (priceEl) priceEl.textContent = currencySymbol + moneyFormat(variant.price);
      if (comparePriceEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          comparePriceEl.textContent = currencySymbol + moneyFormat(variant.compare_at_price);
          comparePriceEl.style.display = '';
        } else {
          comparePriceEl.style.display = 'none';
        }
      }

      if (variant.featured_media && variant.featured_media.id) {
        goToSlideByMediaId(variant.featured_media.id);
      }

      if (variant.available) {
        addCartBtn.disabled = false;
        buyNowBtn.disabled = false;
        addCartLabel.textContent = 'Add to cart';
        statusMsg.textContent = '';
        statusMsg.className = 'pprod-status-msg';
      } else {
        addCartBtn.disabled = true;
        buyNowBtn.disabled = true;
        addCartLabel.textContent = 'Sold out';
        statusMsg.textContent = 'This combination is currently unavailable.';
        statusMsg.className = 'pprod-status-msg is-error';
      }
    }

    selects.forEach(function (sel) {
      sel.addEventListener('change', function () {
        updateForVariant(findMatchingVariant());
      });
    });

    if (!selects.length && variants.length) {
      updateForVariant(variants[0]);
    }

    /* ---------- Quantity ---------- */
    var minusBtn = root.querySelector('[data-qty-minus]');
    var plusBtn = root.querySelector('[data-qty-plus]');

    if (minusBtn) minusBtn.addEventListener('click', function () {
      var val = Math.max(1, (parseInt(qtyInput.value, 10) || 1) - 1);
      qtyInput.value = val;
    });
    if (plusBtn) plusBtn.addEventListener('click', function () {
      var val = (parseInt(qtyInput.value, 10) || 1) + 1;
      qtyInput.value = val;
    });
    if (qtyInput) qtyInput.addEventListener('change', function () {
      var val = parseInt(qtyInput.value, 10);
      if (!val || val < 1) qtyInput.value = 1;
    });

    /* ---------- Cart actions ---------- */
    function currentVariantId() {
      var v = findMatchingVariant();
      if (v) return v.id;
      if (!selects.length && variants.length) return variants[0].id;
      return null;
    }

    /* Adds the current variant to the cart. When openDrawer is true (the
       default) and a <cart-drawer> element exists on the page (rendered
       by our header), this mirrors stock Dawn's product-form.js: it asks
       the drawer which theme sections it needs re-rendered, includes
       that in the /cart/add.js request, then hands the response to the
       drawer's own renderContents() method — which updates the drawer's
       markup AND opens it. "Buy it now" passes openDrawer:false so the
       drawer doesn't flash open right before redirecting to checkout. */
    function addToCart(options) {
      options = options || {};
      var variantId = currentVariantId();
      if (!variantId) return Promise.reject('no-variant');

      var cartDrawer = options.openDrawer !== false ? document.querySelector('cart-drawer') : null;

      var formData = new FormData();
      formData.append('id', variantId);
      formData.append('quantity', parseInt(qtyInput.value, 10) || 1);

      if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
        formData.append(
          'sections',
          cartDrawer.getSectionsToRender().map(function (section) { return section.id; })
        );
        formData.append('sections_url', window.location.pathname);
        if (typeof cartDrawer.setActiveElement === 'function') {
          cartDrawer.setActiveElement(document.activeElement);
        }
      }

      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/javascript' },
        body: formData
      }).then(function (res) {
        if (!res.ok) return res.json().then(function (err) { throw err; });
        return res.json();
      }).then(function (response) {
        if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
          cartDrawer.renderContents(response);
        }
        return response;
      });
    }

    if (addCartBtn) addCartBtn.addEventListener('click', function () {
      if (!ensureVariantSelected()) return;

      addCartBtn.disabled = true;
      statusMsg.textContent = 'Adding...';
      statusMsg.className = 'pprod-status-msg';
      addToCart().then(function () {
        statusMsg.textContent = 'Added to cart.';
        statusMsg.className = 'pprod-status-msg is-success';
        addCartBtn.disabled = false;
        document.dispatchEvent(new CustomEvent('cart:updated'));
      }).catch(function (err) {
        statusMsg.textContent = (err && err.description) ? err.description : 'Could not add to cart. Please try again.';
        statusMsg.className = 'pprod-status-msg is-error';
        addCartBtn.disabled = false;
      });
    });

    if (buyNowBtn) buyNowBtn.addEventListener('click', function () {
      if (!ensureVariantSelected()) return;

      buyNowBtn.classList.add('is-pressed');
      buyNowBtn.disabled = true;
      statusMsg.textContent = 'Redirecting to checkout...';
      statusMsg.className = 'pprod-status-msg';
      addToCart({ openDrawer: false }).then(function () {
        window.location.href = '/checkout';
      }).catch(function (err) {
        statusMsg.textContent = (err && err.description) ? err.description : 'Could not start checkout. Please try again.';
        statusMsg.className = 'pprod-status-msg is-error';
        buyNowBtn.disabled = false;
        buyNowBtn.classList.remove('is-pressed');
      });
    });

    /* ---------- Reset button state when returning to this page ---------- */
    /* window.location.href navigation to /checkout doesn't unload this
       script's state, and browsers often restore this page from bfcache
       exactly as it was (buttons still disabled, "Redirecting..." still
       showing) when the user taps the browser back button. Force a reset
       whenever the page becomes visible again. */
    window.addEventListener('pageshow', function () {
      if (buyNowBtn) {
        buyNowBtn.classList.remove('is-pressed');
      }
      if (statusMsg) {
        statusMsg.textContent = '';
        statusMsg.className = 'pprod-status-msg';
      }
      updateForVariant(findMatchingVariant());
    });

    /* ---------- Related products ---------- */
    var relatedWrap = root.querySelector('.pprod-related');
    if (relatedWrap) {
      var url = relatedWrap.getAttribute('data-url');
      var relatedGrid = relatedWrap.querySelector('[data-related-grid]');
      var relatedPrev = relatedWrap.querySelector('.pprod-related-prev');
      var relatedNext = relatedWrap.querySelector('.pprod-related-next');
      var relatedDots = relatedWrap.querySelector('[data-related-dots]');

      function relatedCardStep() {
        var card = relatedGrid.querySelector('.prel-card');
        if (!card || !relatedGrid) return 0;
        var style = window.getComputedStyle(relatedGrid);
        var gap = parseFloat(style.columnGap || style.gap) || 0;
        return card.getBoundingClientRect().width + gap;
      }

      function relatedCardsPerView() {
        var step = relatedCardStep();
        if (!step || !relatedGrid) return 1;
        return Math.max(1, Math.round(relatedGrid.clientWidth / step));
      }

      function relatedTotalCards() {
        return relatedGrid ? relatedGrid.querySelectorAll('.prel-card').length : 0;
      }

      function relatedPageCount() {
        var perView = relatedCardsPerView();
        var total = relatedTotalCards();
        if (!total) return 1;
        return Math.max(1, Math.ceil(total / perView));
      }

      function relatedCurrentPage() {
        var step = relatedCardStep();
        var perView = relatedCardsPerView();
        if (!step || !relatedGrid) return 0;
        var cardsScrolled = Math.round(relatedGrid.scrollLeft / step);
        return Math.floor(cardsScrolled / perView);
      }

      function updateRelatedArrows() {
        if (!relatedGrid || !relatedPrev || !relatedNext) return;
        var maxScroll = relatedGrid.scrollWidth - relatedGrid.clientWidth;
        var hasOverflow = maxScroll > 4;
        relatedPrev.hidden = !hasOverflow || relatedGrid.scrollLeft <= 4;
        relatedNext.hidden = !hasOverflow || relatedGrid.scrollLeft >= maxScroll - 4;
      }

      function scrollToRelatedPage(page) {
        var step = relatedCardStep();
        var perView = relatedCardsPerView();
        if (!step) return;
        relatedGrid.scrollTo({ left: page * perView * step, behavior: 'smooth' });
      }

      function buildRelatedDots() {
        if (!relatedDots || !relatedGrid) return;
        var pages = relatedPageCount();
        relatedDots.hidden = pages <= 1;
        if (pages <= 1) {
          relatedDots.innerHTML = '';
          return;
        }
        var html = '';
        for (var i = 0; i < pages; i++) {
          html += '<button type="button" class="pprod-related-dot' + (i === 0 ? ' is-active' : '') + '" data-page="' + i + '" aria-label="Go to product set ' + (i + 1) + '"></button>';
        }
        relatedDots.innerHTML = html;
        relatedDots.querySelectorAll('.pprod-related-dot').forEach(function (dot) {
          dot.addEventListener('click', function () {
            scrollToRelatedPage(parseInt(dot.getAttribute('data-page'), 10) || 0);
          });
        });
      }

      function updateActiveRelatedDot() {
        if (!relatedDots) return;
        var current = relatedCurrentPage();
        relatedDots.querySelectorAll('.pprod-related-dot').forEach(function (dot, i) {
          dot.classList.toggle('is-active', i === current);
        });
      }

      if (relatedPrev) relatedPrev.addEventListener('click', function () {
        scrollToRelatedPage(Math.max(0, relatedCurrentPage() - 1));
      });
      if (relatedNext) relatedNext.addEventListener('click', function () {
        scrollToRelatedPage(Math.min(relatedPageCount() - 1, relatedCurrentPage() + 1));
      });

      if (relatedGrid) {
        var relatedScrollTimeout;
        relatedGrid.addEventListener('scroll', function () {
          clearTimeout(relatedScrollTimeout);
          relatedScrollTimeout = setTimeout(function () {
            updateRelatedArrows();
            updateActiveRelatedDot();
          }, 60);
        });
      }
      window.addEventListener('resize', function () {
        clearTimeout(relatedScrollTimeout);
        relatedScrollTimeout = setTimeout(function () {
          updateRelatedArrows();
          buildRelatedDots();
        }, 120);
      });

      fetch(url)
        .then(function (res) { return res.text(); })
        .then(function (html) {
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, 'text/html');
          var fetchedGrid = doc.querySelector('[data-related-grid]');
          if (fetchedGrid && fetchedGrid.children.length) {
            relatedGrid.innerHTML = fetchedGrid.innerHTML;
            updateRelatedArrows();
            buildRelatedDots();
          } else {
            relatedWrap.style.display = 'none';
          }
        })
        .catch(function () {
          relatedWrap.style.display = 'none';
        });
    }
  });
});

  } catch(e) { console.error(e); }
})();
})();
